/**
 * Brand-colored provider icons used by the OAuth Settings page.
 */

import React from 'react';

export const GitHubIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
  </svg>
);

export const GitLabIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M23.6004 9.5927L23.5724 9.5218L20.1444 0.6278C20.0674 0.4418 19.9344 0.2868 19.7654 0.1848C19.5954 0.0818 19.3984 0.0348 19.2004 0.0488C19.0024 0.0628 18.8134 0.1368 18.6574 0.2618C18.5014 0.3868 18.3864 0.5568 18.3274 0.7478L15.9004 7.8538H8.1004L5.6734 0.7478C5.6144 0.5568 5.4994 0.3868 5.3434 0.2618C5.1874 0.1368 4.9984 0.0628 4.8004 0.0488C4.6024 0.0348 4.4054 0.0818 4.2354 0.1848C4.0664 0.2868 3.9334 0.4418 3.8564 0.6278L0.4284 9.5218L0.4004 9.5927C-0.0836 10.9847 -0.1296 12.5117 0.2714 13.9327C0.6724 15.3537 1.5104 16.5907 2.6564 17.4597L2.6644 17.4657L2.6824 17.4797L7.8694 21.3527L10.4574 23.3207L11.7044 24.2737C11.8784 24.4067 12.0874 24.4787 12.3024 24.4787C12.5174 24.4787 12.7264 24.4067 12.9004 24.2737L14.1474 23.3207L16.7354 21.3527L21.9324 17.4717L21.9444 17.4617C23.0904 16.5927 23.9284 15.3557 24.3294 13.9347C24.7304 12.5137 24.6844 10.9867 24.2004 9.5947L23.6004 9.5927Z"
      fill="#E24329"
    />
    <path
      d="M23.6004 9.5927L23.5724 9.5218C21.9564 10.0528 20.4624 10.9028 19.1784 12.0178L12.0004 17.7698L15.9004 7.8538H8.1004L12.0004 17.7698L4.8224 12.0178C3.5384 10.9028 2.0444 10.0528 0.4284 9.5218L0.4004 9.5927C-0.0836 10.9847 -0.1296 12.5117 0.2714 13.9327C0.6724 15.3537 1.5104 16.5907 2.6564 17.4597L2.6644 17.4657L2.6824 17.4797L7.8694 21.3527L10.4574 23.3207L11.7044 24.2737C11.8784 24.4067 12.0874 24.4787 12.3024 24.4787C12.5174 24.4787 12.7264 24.4067 12.9004 24.2737L14.1474 23.3207L16.7354 21.3527L21.9324 17.4717L21.9444 17.4617C23.0904 16.5927 23.9284 15.3557 24.3294 13.9347C24.7304 12.5137 24.6844 10.9867 24.2004 9.5947L23.6004 9.5927Z"
      fill="#FC6D26"
    />
    <path
      d="M12.0004 17.7698L16.7354 21.3527L21.9324 17.4717L21.9444 17.4617C23.0904 16.5927 23.9284 15.3557 24.3294 13.9347C24.7304 12.5137 24.6844 10.9867 24.2004 9.5947L23.6004 9.5927L23.5724 9.5218C21.9564 10.0528 20.4624 10.9028 19.1784 12.0178L12.0004 17.7698Z"
      fill="#FCA326"
    />
    <path
      d="M12.0004 17.7698L7.8694 21.3527L2.6564 17.4597C1.5104 16.5907 0.6724 15.3537 0.2714 13.9327C-0.1296 12.5117 -0.0836 10.9847 0.4004 9.5927L0.4284 9.5218C2.0444 10.0528 3.5384 10.9028 4.8224 12.0178L12.0004 17.7698Z"
      fill="#FC6D26"
    />
  </svg>
);

export const GoogleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      fill="#4285F4"
    />
    <path
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      fill="#34A853"
    />
    <path
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      fill="#EA4335"
    />
  </svg>
);

export const BitbucketIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M.778 1.211a.768.768 0 0 0-.768.892l3.263 19.81c.084.5.515.868 1.022.873H19.95a.772.772 0 0 0 .77-.646l3.27-20.03a.768.768 0 0 0-.768-.891zM14.52 15.53H9.522L8.17 8.466h7.561z"
      fill="#2684FF"
    />
  </svg>
);
